<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';
import { HEAD_TITLE } from '@/globals/constants';

export default {
  name: 'global-utils',
  computed: {
    ...mapGetters(['user', 'device']),
    _device() {
      const {
        platform = '',
        model = '',
        operatingSystem = '',
      } = this.device;
      return {
        iPhone: operatingSystem === 'ios',
        app: platform === 'ios',
        browser: platform === 'web',
        model,
      };
    },
    _timeZone() {
      return this.user?.timeZone || moment.tz.guess();
    },
    HEAD_TITLE() {
      return HEAD_TITLE;
    },
    _featureGate() {
      const features = this.user.features || {};
      return {
        dev: features.dev,
        // admin cant edit owner
        // get ios deployment down
      };
    },
  },
  data() {
    return {
      debounceTime: null,
    };
  },
  methods: {
    _getFullAddress(usr) {
      if (!usr.id) {
        return 'N/A';
      }
      const user = usr.address;
      const apt = user.apt ? `, ${user.apt}` : '';
      const city = user.city ? `, ${user.city}` : '';
      const state = user.state ? `, ${user.state}` : '';
      const country = user.country ? `, ${user.country}` : '';
      const zip = user.zip ? `, ${user.zip}` : '';
      const street = user.street || '';
      const fullAddress = (`${street}${apt}${city}${state}${country}${zip}`).replace(/^, /, '');
      return fullAddress || 'N/A';
    },
    async _getLatLong({ google, address }) {
      const geocoder = new google.api.Geocoder();
      return new Promise((resolve, reject) => {
        geocoder.geocode(
          {
            address,
          },
          (results, status) => {
            // fetch lat and long
            if (status === google.api.GeocoderStatus.OK) {
              resolve({
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng(),
              });
            } else {
              const msg = `geocoder could not find address: ${address}, status: ${status}`;
              this.$log.debug(msg);
              reject(msg);
            }
          },
        );
      });
    },
    _debounce(fn, delay) {
      clearTimeout(this.debounceTime);
      this.debounceTime = setTimeout(() => {
        fn();
      }, delay);
    },
    _formatLocal(date) {
      return moment(date).tz(this._timeZone).format('MM/DD/YYYY');
    },
    _startCase(string) {
      return string.replace(/\w+/g, _.startCase);
    },
    _mockPromise(time, payload) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(payload);
        }, time);
      });
    },
  },
};
</script>
